  const state= {
    drawer: false

  }

  const actions = {
    toggleDrawer (context) {
      context.commit('toggleDrawer')
    },
    updateDrawer (context, value) {
      context.commit('updateDrawer', value)
    }
  }
  const getters = {
    drawer: (state) => {
      return state.drawer;
    },
  }

  const mutations= {
    openDrawer (state) {
      state.drawer = true
    },
    closeDrawer (state) {
      state.drawer = false
    },
    toggleDrawer (state) {
      //console.log("toggleDrawer before: ", state.drawer)
      state.drawer = !state.drawer
      //console.log("toggleDrawer after: ", state.drawer)
    },
    updateDrawer (state, value) {
      state.drawer = value;
    }
  }

  export const navbar = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }